"use client";
import { useCallback, useEffect, useState } from "react";
import AnchorTTK from "./AnchorTTK.jsx";
import ArtistTTK from "./ArtistTTK.jsx";
import BirthadayClubingTTK from "./BirthadayClubingTTK.jsx";
import BirthadayShoppingTTK from "./BirthadayShoppingTTK.jsx";
import BirthadayTTK from "./BirthadayTTK.jsx";
import BrassBandTTK from "./BrassBandTTK.jsx";
import BridalWearTTK from "./BridalWearTTK.jsx";
import BridalmakeupTTK from "./BridalmakeupTTK.jsx";
import BusRentalTTK from "./BusRentalTTK.jsx";
import CakeShopTTK from "./CakeShopTTK.jsx";
import CarRentalTTK from "./CarRentalTTK.jsx";
import CateringTTK from "./CateringTTK.jsx";
import ChoreographerTTK from "./ChoreographerTTK.jsx";
import DecoratorsTTK from "./DecoratorsTTK.jsx";
import DestinationWedTTK from "./DestinationWedTTK.jsx";
import EntryThemeTTK from "./EntryThemeTTK.jsx";
import FlourishTTK from "./FlourishTTK.jsx";
import GiftsTTK from "./GiftsTTK.jsx";
import GroomWearTTK from "./GroomWearTTK.jsx";
import HelecopterBookingTTK from "./HelecopterBookingTTK.jsx";
import InvitationTTK from "./InvitationTTK.jsx";
import LiveMusicBandTTK from "./LiveMusicBandTTK.jsx";
import MagicianTTK from "./MagicianTTK.jsx";
import MehandiTTK from "./MehandiTTK.jsx";
import OnRentTTK from "./OnRentTTK.jsx";
import PanditTTK from "./PanditTTK.jsx";
import PhotographyTTK from "./PhotographyTTK.jsx";
import SafaTTK from "./SafaTTK.jsx";
import TourPackageTTK from "./TourPackageTTK.jsx";
import VenueTTK from "./VenueTTK.jsx";
import VintageCarTTK from "./VintageCarTTK.jsx";
import WeddingDjTTK from "./WeddingDjTTK.jsx";
import WeddingPlannerTTk from "./WeddingPlannerTTk.jsx"
const TtkContainerStatusMgmt = ({ data, sub_cat_id }) => {
   switch (sub_cat_id) {
    case "52vn6kWKmCCUGk6DqKfM":
      return <VenueTTK data={data} />;
    case "8x7UFtmckFjIuWUA4oaj":
      return <VenueTTK data={data} />;
    case "Gsj5h6LfHMqWKbbWDdeh":
      return <VenueTTK data={data} />;
    case "WgPT5AjEU6y3lnpxxkIq":
      return <VenueTTK data={data} />;
    case "8EaQ32WZPPKQHhCb0rHa":
      return <PhotographyTTK data={data} />;
    case "gnv1ceUBFqhcU1F3w6S1":
      return <FlourishTTK data={data} />;
    case "FXDStEgXe9RXLiFFFMjn":
      return <SafaTTK data={data} />;
    case "kMqFV87nKkkOMDGRLYm8":
      return <MagicianTTK data={data} />;
    case "REgfHYF9tUNeip9MoIiJ":
      return <BridalmakeupTTK data={data} />;
    case "lNajYmRId9agpdMfQgBP":
      return <MehandiTTK data={data} />;
    case "KiR4d4mTOa9wO1Ug794b":
      return <WeddingDjTTK data={data} />;
    case "cL3ML2kGQq73UwopisjS":
      return <DecoratorsTTK data={data} />;
    case "UVEU5Cu4lBTzTc6U1LLC":
      return <PanditTTK data={data} />;
    case "YzLGveDq8B4NGRaMynrF":
      return <AnchorTTK data={data} />;
    case "JmVQxGbqLzy5vQleF7Vo":
      return <InvitationTTK data={data} />;
    case "KSBiIS1ozXjskiuYSRh8":
      return <GroomWearTTK data={data} />;
    case "Ro7Bc5o3VyK0c7rFVBRv":
      return <LiveMusicBandTTK data={data} />;
    case "NJ24jdxiqTCPhKsPHpfM":
      return <GiftsTTK data={data} />;
    case "fklaMSittpqblXbJ5fk4":
      return <TourPackageTTK data={data} />;
    case "YlYeYg6PFa24U3aUw5XY":
      return <CarRentalTTK data={data} />;
    case "v0jnBiBS1p3Y2fTOrgLE":
      return <CakeShopTTK data={data} />;
    case "ifDgK6rfWHdve2yAb8IX":
      return <BusRentalTTK data={data} />;
    case "EOwVeI2xdMAWYyMB9Ged":
      return <BrassBandTTK data={data} />;
    case "UTYv8zIn3ePt3ZkcKXow":
      return <BirthadayShoppingTTK data={data} />;
    case "XfRVyejjN7EPxxVmGNA2":
      return <BirthadayClubingTTK data={data} />;
    case "zqq7qmE7wtG838LDX8hJ":
      return <CateringTTK data={data} />;
    case "RBwoc5b7vB2yRl5aHDFm":
      return <OnRentTTK data={data} />;
    case "HT33vunkJlPeg1kiP7K2":
      return <DestinationWedTTK data={data} />;
    case "To7Chd4Ld4UOo68GzWxq":
      return <DestinationWedTTK data={data} />;
    case "YsD4nfH3n21oW1lS9V6I":
      return <DestinationWedTTK data={data} />;
    case "tqnzPLgJvzZGg5AR0cQP":
      return <DestinationWedTTK data={data} />;
    case "R1Bi9kPxOfsqRwW9oiWk":
      return <BridalWearTTK data={data} />;
    case "t5CjPhRmhZAgJ5ZxXKlQ":
      return <WeddingPlannerTTk data={data} />;
    case "OcgLXWiDaSZxNQniDKwS":
      return <ChoreographerTTK data={data} />;
    case "7kMNlcnAOtLsRMVtqn6R":
      return <VintageCarTTK data={data} />;
    case "Eun3JvVRoFLb4nBvq0hH":
      return <HelecopterBookingTTK data={data} />;
    case "iAfD04pQNNJjvBLA4jeF":
      return <WeddingPlannerTTk data={data} />;
    case "cLkJjfUeVHHAV3uYy7rN":
      return <WeddingPlannerTTk data={data} />;
    case "UyZXebMRha8pT62o7NFX":
      return <BirthadayTTK data={data} />;
    case "y1cmw5s4CbGXZsEJCfxk":
      return <EntryThemeTTK data={data} />;
    case "IYURZPvwTK49OVN3eHqS":
      return <ArtistTTK data={data} />;
    default:
      return null;
  }
};

export default TtkContainerStatusMgmt;
